import { Button, FormField } from '../components/ui';
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../api/client';
import { ThemeToggle } from '../context/ThemeContext';
import BrandMark from '../components/BrandMark';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setLoading(true);
    setError('');
    try {
      const user = await api.loginUser(email.trim(), password);
      login(user);
      const target = location.state?.returnTo;
      navigate(typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') ? target : '/', { replace: true });
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Неверный email или пароль.');
      } else {
        setError('Ошибка при входе. Попробуйте ещё раз.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="auth-theme"><ThemeToggle /></div>
      <div className="login-card">
        <div className="login-logo">
          <BrandMark />
          <h1 className="login-title">Agent R&amp;D Platform</h1>
        </div>
        <form onSubmit={handleLogin} className="login-form">
          <h2 className="login-form-title">Вход</h2>
          <p className="login-hint">Ваши проекты, исследования и команда агентов.</p>
          <FormField label={<>Email</>}>
          <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" autoFocus required />
          </FormField>
          <FormField label={<>Пароль</>}>
          <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
          </FormField>
          {error && <div className="login-error">{error}</div>}
          <Button className="btn btn-primary login-btn" type="submit" disabled={loading}>
            {loading ? 'Вход...' : 'Войти'}
          </Button>
        </form>
      </div>
    </div>
  );
}
